module.exports = __webpack_public_path__ + "static/media/ao.4e70ca93.svg";